<template>
  <div id="body">
    <div id="login-wrapper">
      <!--
        スライダーを使用するときは以下3点をtrueにする。
        :paginationEnabled="false"
        :mouseDrag="false"
        :touchDrag="false"-->
      <Carousel
        id="login-slider"
        ref="carousel"
        :autoplay="true"
        :autoplayTimeout="4500"
        :loop="true"
        :perPage="1"
        :speed="500"
        :minSwipeDistance="100"
        :paginationEnabled="true"
        :mouseDrag="true"
        :touchDrag="true"
      >
        <template v-for="(item, index) in group1.slideList">
          <Slide :key="'slide_' + index" :id="item.slide_id" v-html="item.html"></Slide>
        </template>
      </Carousel>
      <div class="login-contents">
        <div class="login-contents-inr">
          <div class="login-box-login">
            <div class="login-box-logo"><img src="/lc/app/images/logo-snhoki.png" alt="新日本法規出版株式会社"></div>
            <div class="login-box-head">
              <h1>
                <img src="/lc/app/images/logo-blue.svg" class="login-snol" alt="LEGAL CONNECTION">
              </h1>
            </div>
            <form @submit.prevent>
              <div class="login-box-form">
                <div>
                  <input type="email" v-model="group1.loginId" placeholder="メールアドレス">
                </div>
                <p v-if="group1.error_loginId" class="error-message">{{ group1.error_loginId }}</p>
                <div>
                  <input type="password" v-model="group1.password" placeholder="パスワード">
                </div>
                <p v-if="group1.error_password" class="error-message">{{ group1.error_password }}</p>
              </div>
              <div class="login-btn-wrp">
                <div class="button login-btn"><button type="button" @click="group1.onLoginButtonClicked" class="btn">ログイン</button></div>
                <div class="formparts checkbox login-password">
                  <input type="checkbox" v-model="group1.savePassword" id="save_password">
                  <label for="save_password">パスワードを保存する<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
                <div class="login-passwordreminder">
                  <router-link class="btn" to="/public/password-reminder/index">パスワードを変更する</router-link>
                </div>
              </div>
            </form>
          </div>
          <div class="login-about-wrap">
            <a href="/lc/about/" target="_blank">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <div class="login-link-wrp">
            <ul class="login-link-01">
              <li><button @click="group1.onNewContractButtonClicked">新規契約申込</button></li>
              <li><router-link to="/public/estimate/index">お見積もり</router-link></li>
              <li><router-link to="/public/inquiry/index">お問い合わせ</router-link></li>
            </ul>
            <ul class="login-link-02">
              <li><a href="https://www.sn-hoki.co.jp/guide/social_rules/" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
              <li><a href="https://www.sn-hoki.co.jp/privacy/" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
              <li><a href="https://www.sn-hoki.co.jp/guide/tradelaw/" target="_blank">特定商取引法に基づく表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
            </ul>
            <p class="login-copyright">Copyright (C) 2021 SHINNIPPON-HOKI PUBLISHING CO.,LTD.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicLogin from '@/logic/Login'
import { Carousel, Slide } from 'vue-carousel'

export default defineComponent({
  components: {
    Carousel,
    Slide
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLogin.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#login-wrapper{
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 100vh;
  overflow: hidden;
}
.login-contents{
  position: absolute;
  top: 0;
  right: 0;
  width: 640px;
  height: 100vh;
  overflow: hidden;
}
.login-box-logo {
  position: absolute;
  top: -27px;
  left: 31px;
  height: 30px;

  @media screen and (max-width: 1280px) {
    top: -9px;
    left: 40px;
  }
}
.login-box-logo img {
  height: 100%;
  width: auto;
}
@keyframes loginbg1 {
  0% {
    background: rgba(0, 0, 0, 0.1);
  }
  100% {
    background: rgba(0, 0, 0, 0.1);
  }
}
.login-contents-inr{
  overflow: auto;
  height: 100vh;
  background: #FFF;
}
.login-box-login{
  position: relative;
  margin: 40px 0 0;
  padding: 75px 120px 56px;
  border-radius: 5px;
  &:before{
    content: '';
    position: absolute;
    background: #F9F8F6;
    box-shadow: 0px 5px 20px #00000029;
    -moz-animation: loginbg2 1s infinite;
    -ms-animation: loginbg2 1s infinite;
    border-radius: 8px;
    opacity: 0.2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
}
@keyframes loginbg2 {
  0% {
    background: #fff;
    opacity: 0.3;
  }
  100% {
    background: #fff;
    opacity: 0.3;
  }
}
.login-box-head{
  position: relative;
  h1{
    text-align: center;
  }
}
.login-box-form{
  margin-top: 23px;
  div{
    position: relative;
    border-bottom: 1px solid #fff;
    input[type="password"],
    input[type="email"],
    input[type="text"]{
      width: 100%;
      margin-top: 25px;
      padding: 16px 0;
      border-bottom: 1px solid #005BAC;
      outline: none;
      font-size: 18px;
      &::placeholder {
        color: rgba(#005BAC,.4);
      }
    }
    svg{
      position: absolute;
      bottom: 22px;
      right: 5px;
      color: #005BAC;
      cursor: pointer;
    }
  }
}
.login-btn-wrp{
  text-align: center;
}
.login-btn{
  width: 200px;
  margin: 40px auto 0;
}
.login-btn .btn {
  border: 0;
  background-color: $color-link;
  color: #FFF;
}
.login-password{
  display: inline-block;
  margin-top: 20px;
  label{
    cursor: pointer;
    color: $color-link;
    &:after {
      border: 1px solid $color-line;
      background-color: #FFF;
    }
  }
}
.login-passwordreminder{
  margin-top: 32px;
  font-size: 12px;
  color: #fff;
  a{
    font-size: 12px;
    color: $color-link;
  }
}

.login-trial-wrap{
  text-align: center;
  padding: 0px 75px 40px 75px;
}

.login-trial-btn {
  display: flex;
  justify-content: center;
  .btn {
    width: 360px;
    max-width: 100%;
    padding: 16px 0;
    background: #fff;
    border: 1px solid $color-line;
    border-radius: 8px;
    opacity: 1;
    transition: all 0.1s ease-out;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
    font-weight: bold;
    &:hover {
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.16);
      transition: all 0.1s ease-out;
    }
    >.sub, .main {
      display: block;
      line-height: 1;
    }
    .sub {
      font-size: 14px;
      color: #3AACE2;
    }
    .main {
      margin-top: 10px;
      color: #005BAC;
    }
  }
}

.login-about-wrap{
  text-align: center;
  padding: 0px 120px 75px;
  a{
    // font-size: 14px;
    // font-weight: bold;
    color: $color-link;
    svg{
      margin-left: 5px;
    }
  }
}

.login-link-wrp{
  padding: 30px 2vw 30px;
  text-align: right;
  background: $color-bg-paper;
}
.login-link-01{
  font-size: 14px;
  letter-spacing: -0.4em;
  list-style: none;
  li{
    display: inline-block;
    letter-spacing: normal;
    & + li{
      margin-left: 1.2vw;
    }
    a, button{
      color: $color-link;
    }
  }
}
.login-link-02{
  margin-top: 10px;
  font-size: 12px;
  letter-spacing: -0.4em;
  list-style: none;
  li{
    display: inline-block;
    letter-spacing: normal;
    & + li{
      margin-left: 1.2vw;
    }
    a, button {
      color: $color-link;
    }
  }
}
.login-copyright{
  margin-top: 10px;
  font-size: 12px;
  color: $color-sup;
  opacity: .8;
}
.error-message {
  margin-top: 16px;
}

  // スライドショー専用CSS（Vueの外部に設置）
  @import '/lc/app/top_slideshow/pc_top_slideshow.css';
</style>
